import { useState } from "react";
import { Link } from "wouter";
import { INDEX_SYMBOL } from "../lib/data";

export default function FaqSection({ id = "faq", data }) {
  const schedule = data?.schedule || {};
  const payoutMin = schedule.payoutIntervalMin || 10;
  const basketMin = schedule.basketRefreshMin || data?.basket?.refreshMin || 60;
  const minSol = schedule.minDistributeSol ?? 0.02;

  const faqs = [
    {
      q: `What is $${INDEX_SYMBOL}?`,
      a: `$${INDEX_SYMBOL} is the Stonksindex share token on StonkFun (standard fee mode, 2% tier). Trading fees accrue to the creator wallet, which the worker claims to fund the rotating basket.`,
    },
    {
      q: "How does the basket get chosen?",
      a: `The worker scores StonkFun markets using mcap, 24h volume, liquidity, and 24h change, applies floors, then weights the top names. The board refreshes every ${basketMin} minutes — History shows enter/exit diffs.`,
    },
    {
      q: "When do holders get paid?",
      a: `Payouts attempt every ${payoutMin} minutes on a UTC clock (homepage countdown). A cycle only buys the board when liquid fees (treasury SOL above reserve, plus any fee-quote balance) clear about ${minSol} SOL. Then: buy basket weights → airdrop pro-rata to $${INDEX_SYMBOL} holders with at least ${data?.schedule?.minHolderTokens ?? 10000} tokens. See Cycles for archived runs.`,
    },
    {
      q: "How does the lottery work?",
      a: `About ${data?.lottery?.lotteryPct ?? data?.schedule?.lotteryPct ?? 10}% of each spend cycle accrues to a SOL pot. Draws fire on a random ${data?.lottery?.intervalMin ?? 20}–${data?.lottery?.intervalMax ?? 60} minute cadence. Every eligible holder gets one ticket — bag size does not change your odds. Past winners live on the Lottery page.`,
    },
    {
      q: `Is there a minimum $${INDEX_SYMBOL} balance to earn rewards?`,
      a: `Yes — you need at least ${data?.schedule?.minHolderTokens ?? 10000} $${INDEX_SYMBOL} (${data?.schedule?.indexDecimals ?? 6} decimals) to be included in airdrops and the lottery. Below that, wallets are skipped for that cycle.`,
    },
    {
      q: "Why did a payout window skip?",
      a: `If liquid fees are below ~${minSol} SOL after the SOL reserve (and after ATA rent set-aside), that window is a no-op — nothing is broken, volume just hasn’t topped up the treasury enough yet. The homepage shows “Waiting on fees” when this happens. Fees keep accruing from $SI trading; the next ${payoutMin}-minute attempt retries.`,
    },
    {
      q: "How does the community board seat work?",
      a: `Most seats are score-ranked. One seat is holder-voted: pick a candidate, send a tiny SOL dust to the treasury with an exact memo (so nobody can hijack your tip), paste the tx signature. You still need ≥${data?.schedule?.minHolderTokens ?? 10000} $${INDEX_SYMBOL}. One vote per address. Winner pins into the basket — see Community.`,
    },
    {
      q: "What is an ATA and why does it matter?",
      a: "An Associated Token Account holds a specific mint for your wallet. If you lack an ATA for a basket token, the worker may create one (when rent budget allows) or pay that leg in SOL instead. Portfolio → ATA troubleshooting shows which accounts are open or missing.",
    },
    {
      q: "I closed a token account — will I still get rewards?",
      a: "If you close an ATA after the worker paid rent to open it, you may be blacklisted from free recreates and receive SOL for that mint instead. Keep accounts open if you want token airdrops.",
    },
    {
      q: "Is this financial advice?",
      a: "No. Memecoins and launchpad assets are volatile and can go to zero. Read Terms and Privacy. You are responsible for your own wallets and trades.",
    },
  ];

  const [open, setOpen] = useState(0);

  return (
    <section className="app-section faq-section" id={id}>
      <div className="shell">
        <div className="section-intro">
          <p className="section-kicker">
            <i className="brand-diamond" aria-hidden /> FAQ
          </p>
          <h2 className="section-title">Questions, answered</h2>
          <p className="section-lead left">
            Fees, baskets, airdrops, and ATAs — the short version.
          </p>
        </div>

        <div className="faq-list">
          {faqs.map((item, i) => {
            const isOpen = open === i;
            return (
              <div className={`faq-item${isOpen ? " is-open" : ""}`} key={item.q}>
                <button
                  type="button"
                  className="faq-q"
                  aria-expanded={isOpen}
                  onClick={() => setOpen(isOpen ? -1 : i)}
                >
                  <span>{item.q}</span>
                  <i aria-hidden>{isOpen ? "−" : "+"}</i>
                </button>
                {isOpen && <div className="faq-a">{item.a}</div>}
              </div>
            );
          })}
        </div>

        <div className="section-actions section-actions--row" style={{ marginTop: "1.25rem" }}>
          <Link href="/docs" className="btn btn-ghost">
            Full docs
          </Link>
          <Link href="/portfolio" className="btn btn-lime">
            Check ATAs
          </Link>
        </div>
      </div>
    </section>
  );
}
